import { useDispatch } from "react-redux";
import { useRef, useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import Authenticator from "./Authenticator";
import { errorRoutes } from "../../routes/error";
import { useAppSelector } from "../../redux/hooks";
import { Thematic } from "../../components/utils/Thematic";
import { revokeIdentity } from "../../redux/idenTT_Actions";
import { SideMenu } from "../../components/layouts/SideMenu";
import { StandardHeader } from "../../components/layouts/StandardHeader";
import { standardRoutes } from "../../routes/standard";
import { PageProvider } from "./PageContext";

export default function StandardGuard() {
    const dispatch: any = useDispatch();
    const identitySession = useAppSelector(state => state.identity);

    const location = useLocation()
    const currentLocation = location.pathname;

    const state = { from: currentLocation };
    const sessionState = Authenticator.Check(identitySession);

    const hasRevokedIdentity = useRef(false);
    const [shouldRedirect, setShouldRedirect] = useState(false);

    useEffect(() => {
        if (sessionState.resetSession && !hasRevokedIdentity.current) {
            dispatch(revokeIdentity());

            setShouldRedirect(true);
            hasRevokedIdentity.current = true;
        }
    }, [sessionState, dispatch]);

    if (shouldRedirect) {
        return <Navigate to="/auth/sign-in" replace />;
    }

    if (sessionState.resetSession) {
        /* 
         * Redux session state is authenticated
         * but cookies are not set.
         * Reset session and start all-over again
        */
        return
    } else if (!sessionState.authenticated) {
        return <Navigate to="/auth/sign-in" replace state={state} />;
    } else if (!sessionState.statusExists) {
        return <Navigate to={'/auth/identity/trust/gate'} replace state={state} />;
    } else {
        if (sessionState.status !== 'ACTIVE') {
            const accountStatusRoute: any = (
                errorRoutes.find((routeName) => routeName.name === 'BNF_STATUS_')
            )?.path

            return <Navigate to={accountStatusRoute} replace />;
        }
    }

    const MNuFindRouteAndMatch = () => {
        const pathname = location.pathname

        for (const item of standardRoutes) {
            // Check if the current item's route starts with the targetRoute
            if (item.path && pathname.startsWith(item.path)) {
                return item.activeMenu
            }
        }

        return null;
    }

    return (
        <PageProvider>
            <Thematic>
                <div className={`h-screen flex flex-col bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-400 w-full`}>

                    <SideMenu ActiveMNu={MNuFindRouteAndMatch()} />

                    <div className="flex-grow flex pt-14">
                        <StandardHeader />

                        <main className="lg:ml-72 md:ml-60 flex-1 h-[calc(100vh-3.5rem)]">

                            <Outlet />

                        </main>
                    </div>
                </div>
            </Thematic>
        </PageProvider>
    )
}